import request from "@/utils/request";
import baseUrl from "@/utils/base-url";

//我的收藏  //获取收藏列表
export function favor(data) {
    return request({
      url:baseUrl.base+'/favorlist',
      method: "get",
      params: data
    })
  }


//我的收藏  //获取收藏列表
export function addfavor(data) {
    return request({
      url:baseUrl.base+'/favor/add',
      method: "post",
      params: data
    })
  }

//我的收藏  //获取收藏列表
export function removefavor(data) {
    return request({
      url:baseUrl.base+'/favor/remove',
      method: "post",
      params: data
    })
  }
// https://tiku.chexuetang.cn/mp/exam/mycollection 